import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      // href='https://github.com/ayman-bit/portfolio'
      className='link footer__link'
    >
      © 2023
    </a>
  </footer>
)

export default Footer
